// export const enum TabTypes {
// 	TEST = 'TAB.TEST',
// 	CUSTOMERS = 'TAB.CUSTOMERS',
// 	CUSTOMERS_NEW = 'TAB.CUSTOMERS_NEW',
// 	SERVICES = 'TAB.SERVICES',
// 	SERVICES_NEW = 'TAB.SERVICES_NEW',
// 	CONTRACTS = 'TAB.CONTRACTS',
// 	CONTRACTS_NEW = 'TAB.CONTRACTS_NEW',
// 	INVOICES = 'TAB.INVOICES',
// 	INVOICES_NEW = 'TAB.INVOICES_NEW',
// 	PAYMENTS = 'TAB.PAYMENTS',
// 	PAYMENTS_NEW = 'TAB.PAYMENTS_NEW',
// 	UAC = 'TAB.UAC'
// }

import {t} from "../core/localization";
import {AppConfig} from "../config";
t.setLanguage(AppConfig().language)

export interface Tab {
	id: string,
	title: string,
	type: TabTypes,
	item?: any,
	state: any // represents the state of the tab, inputs, sorting, filtering, etc.
	rang: number,
	data: any
}

export interface TabTypeData {
	title: string,
	multiple: boolean
}

export class TabTypes {

	static readonly CUSTOMERS = new TabTypes('TAB.CUSTOMERS', t.Customers, false)
	static readonly CUSTOMERS_NEW = new TabTypes('TAB.CUSTOMERS_NEW', t.NewCustomer,false)
	static readonly CUSTOMER_FINANCES = new TabTypes('TAB.CUSTOMER_FINANCES', t.Finances, true) // TODO Milos: find a way to pass customer object as item without multiple
	static readonly CATEGORIES = new TabTypes('TAB.CATEGORIES', t.Categories, false)
	static readonly CATEGORIES_NEW = new TabTypes('TAB.CATEGORIES_NEW', t.NewCategory, false)
	static readonly SERVICES = new TabTypes('TAB.SERVICES', t.Services, false)
	static readonly SERVICES_NEW = new TabTypes('TAB.SERVICES_NEW', t.NewService, false)
	static readonly CONTRACTS = new TabTypes('TAB.CONTRACTS', t.Contracts, false)
	static readonly CONTRACTS_NEW = new TabTypes('TAB.CONTRACS_NEW', t.NewContract, false)
	static readonly INVOICES = new TabTypes('TAB.INVOICES', t.Invoices, false)
	static readonly INVOICES_NEW = new TabTypes('TAB.INVOICES_NEW', t.NewInvoice, false)
	static readonly PAYMENTS = new TabTypes('TAB.PAYMENTS', t.Payments, false)
	static readonly PAYMENTS_NEW = new TabTypes('TAB.PAYMENTS_NEW', t.NewPayment, false)
	static readonly USERS = new TabTypes('TAB.USERS', t.Users, false)
	static readonly USERS_NEW = new TabTypes('TAB.USERS_NEW', t.User, false)
	static readonly ROLES = new TabTypes('TAB.ROLES', t.Roles, false)
	static readonly ROLES_NEW = new TabTypes('TAB.ROLES_NEW', t.Role, false)
	static readonly TENANT = new TabTypes('TAB.TENANT', "Sitemski podaci", false)
	static readonly REPORT_INVOICES_PAYMENTS = new TabTypes('TAB.REPORT_INVOICES_PAYMENTS', t.Reports, false)
	static readonly REPORT_SERVICES = new TabTypes('TAB.REPORT_SERVICES', t.Reports, false)
	static readonly DOCUMENT_NEW = new TabTypes('TAB.DOCUMENTS_NEW', 'Novi dokument',false)
	static readonly DOCUMENTS = new TabTypes('TAB.DOCUMENTS', 'Dokumenta',false)
	static readonly DOCUMENTS_SEARCH = new TabTypes('TAB.DOCUMENTS_SEARCH', 'Pretraga dokumenata',false)
	static readonly DOCUMENTS_INDEXING = new TabTypes('TAB.DOCUMENTS_INDEXING', 'Dokumenta za indeksiranje',false)
	static readonly FOLDERS_NEW = new TabTypes('TAB.FOLDERS_NEW', 'Nova fascikla',false)
	static readonly UAC = new TabTypes('TAB.UAC')
	static readonly DEPARTMENTS = new TabTypes('TAB.DEPARTMENTS', t.Department, false)
	static readonly DEPARTMENTS_NEW = new TabTypes('TAB.DEPARTMENT_NEW', t.NewDepartment, false)
	static readonly POSITIONS = new TabTypes('TAB.POSITIONS', t.Position, false)
	static readonly POSITIONS_NEW = new TabTypes('TAB.POSITIONS_NEW', t.NewPosition, false)
	static readonly EMPLOYEES = new TabTypes('TAB.EMPLOYEES', t.Employee, false)
	static readonly EMPLOYEES_NEW = new TabTypes('TAB.EMPLOYEES_NEW', t.NewEmployee, false)
	static readonly NOTIFICATIONS = new TabTypes('TAB.NOTIFICATIONS', t.Notifications, false)
	static readonly NOTIFICATIONS_NEW = new TabTypes('TAB.NOTIFICATIONS_NEW', t.NewNotification, false)
	static readonly DASHBOARD = new TabTypes('TAB.DASHBOARD', 'Dashboard', false)


	// private to disallow creating other instances of this type
	private constructor(public key: string, public readonly title: any = 'not defined', public readonly multiple: boolean = true) {
	}

	toString() {
		return this.key;
	}

	public defaultTitle (): string {
		return this.title
	}
}
